<div class="mb-5">
  <form [formGroup]="addPhoneNumberForm" (ngSubmit)="submitHandler()">
    <app-shared-input
      label="Phone number"
      for="phoneNumber"
      [value]="addPhoneNumberForm.value.phoneNumber || ''"
      [focused]="focused"
      [touched]="addPhoneNumberForm.get('phoneNumber')?.touched"
      [errors]="addPhoneNumberForm.get('phoneNumber')?.errors"
      [disabled]="!!(loading$ | async)"
      prefix="+1"
    >
      <input
        formControlName="phoneNumber"
        name="phoneNumber"
        id="phoneNumber"
        type="tel"
        (paste)="pastePhoneNumberHandler($event)"
        (focus)="focused = true"
        (blur)="focused = false"
        mask="(000) 000-0000"
      />
    </app-shared-input>

    <div class="actions">
      <app-shared-button size="small" [loading]="!!(loading$ | async)">
        Add Phone Number
      </app-shared-button>
    </div>
  </form>
</div>

<div class="mt-7">
  Logged in as <span class="font-semibold">{{ userName }}</span
  >. Not you?
  <a routerLink="/logout"> Sign in with a different account </a>
</div>
